import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Snackbar from '@material-ui/core/Snackbar'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import StarIcon from '@material-ui/icons/Star'
import StarBorderIcon from '@material-ui/icons/StarBorder'
import { Rating } from '@material-ui/lab'
import Alert from '@material-ui/lab/Alert'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { ModalNotAuth } from '../../Components'
import Breadcrumb from '../../Components/Breadcrumb'
import colorContext from '../../Context/colorContext'
import evaluationMain from '../../services/avaliacao'
import getCookie from '../../utils/getCookies'
import Title from './components/Title'

export default function Accessibility(): JSX.Element {
  const { colors } = useContext(colorContext)
  const useStyles = makeStyles((theme) => ({
    main: {
      width: '100%',
      minHeight: 500,
      display: 'flex',
      backgroundColor: colors.colorBackground,
      flexDirection: 'column',
      alignItems: 'center',
      color: colors.textBody,
      lineHeight: '24px',
    },
    boxRating: {
      display: 'flex',
      alignItems: 'center',
      width: '55%',
      flexDirection: 'column',
      marginBottom: '55px',
      marginTop: 55,
      padding: '40px 20px',
      borderRadius: 8,
      [theme.breakpoints.down('sm')]: {
        width: '95%',
        padding: '20px 12px',
        marginTop: 30,
        marginBottom: 30,
      },
    },
    ratingTitle: {
      color: colors.textBody,
      textTransform: 'uppercase',
      fontFamily: 'Roboto',
      fontSize: 28,
      margin: '0px 10px',
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        fontSize: 20,
        margin: '0px 6px',
      },
    },
    ratingCount: {
      marginTop: 10,
      fontSize: 16,
      color: colors.textBody,
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        fontSize: 14,
        marginTop: 6,
      },
    },
    starIcon: {
      color: colors.accentColor,
      width: 45,
      height: 45,
      [theme.breakpoints.down('sm')]: {
        width: 36,
        height: 36,
      },
    },
    starBox: {
      padding: '10px',
      [theme.breakpoints.down('sm')]: {
        padding: '6px',
      },
    },
    textareaComment: {
      width: 550,
      height: 120,
      backgroundColor: colors.colorBackgroundSecundary,
      color: colors.textBody,
      padding: 10,
      fontSize: 18,
      fontFamily: 'Roboto',
      border: `1px solid ${colors.accentColor}`,
      borderRadius: 4,
      resize: 'none',
      marginTop: 40,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        maxWidth: '100%',
        height: 100,
        fontSize: 16,
        marginTop: 20,
      },
    },
    buttonSend: {
      textTransform: 'uppercase',
      borderRadius: 4,
      minWidth: 130,
      height: 44,
      marginTop: 55,
      background: colors.accentColorBackground,
      alignSelf: 'flex-end',
      fontSize: 18,
      color: colors.textAccentColor,
      [theme.breakpoints.down('sm')]: {
        alignSelf: 'stretch',
        width: '100%',
        minWidth: 'auto',
        marginTop: 16,
        fontSize: 16,
      },
    },
  }))
  const classes = useStyles()
  const history = useHistory()
  const [isUser, setIsUser] = useState<boolean>(true)
  const [ratingService, setRatingService] = useState<number>(5)
  const [comments, setComments] = useState<string>('')
  const [snack, setSnack] = useState<{
    open: boolean
    message: string
    severity: 'success' | 'error'
  }>({ open: false, message: '', severity: 'success' })
  const redirectTimeout = useRef<number | undefined>(undefined)

  useEffect(() => {
    return () => {
      if (redirectTimeout.current) {
        window.clearTimeout(redirectTimeout.current)
      }
    }
  }, [])

  const handleRating = (e, value: number | null) => {
    setRatingService(value || 0)
  }

  const handleComment = async () => {
    const token: string | null = getCookie('gov_access_token_sso')
    if (token) {
      setIsUser(true)
      try {
        await evaluationMain({
          tipo: 'Portal',
          avaliacao_plataforma: ratingService,
          comentario_plataforma: comments,
          token,
        })
        setSnack({
          open: true,
          message: 'Avaliação enviada com sucesso.',
          severity: 'success',
        })
        redirectTimeout.current = window.setTimeout(() => {
          history.push('/')
        }, 2000)
      } catch (err) {
        console.error(err)
        setSnack({
          open: true,
          message: 'Falha ao enviar a avaliação.',
          severity: 'error',
        })
        redirectTimeout.current = window.setTimeout(() => {
          history.push('/')
        }, 2000)
      }
    } else {
      setIsUser(false)
    }
  }

  return (
    <Box className={classes.main}>
      <Breadcrumb slug="Pesquisa de satisfação" />
      <Title />
      <Box className={classes.main}>
        <ModalNotAuth open={!isUser} onClose={(): void => setIsUser(true)} />
        <Box className={classes.boxRating}>
          <Typography className={classes.ratingTitle}>
            Avalie a plataforma Salvador Digital
          </Typography>
          <Typography className={classes.ratingCount}>
            {`${ratingService} estrela${ratingService === 1 ? '' : 's'}`}
          </Typography>
          <Rating
            size="large"
            value={ratingService}
            onChange={handleRating}
            name="simple-controlled"
            icon={
              <Box className={classes.starBox}>
                <StarIcon className={classes.starIcon} />
              </Box>
            }
            emptyIcon={
              <Box className={classes.starBox}>
                <StarBorderIcon className={classes.starIcon} />
              </Box>
            }
          />
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <textarea
              aria-label="Comentário"
              className={classes.textareaComment}
              placeholder="Escreva aqui seu comentário..."
              maxLength={200}
              value={comments}
              onChange={(e) => setComments(e.target.value)}
            />
            <Button
              variant="contained"
              className={classes.buttonSend}
              onClick={handleComment}
            >
              Avaliar
            </Button>
          </Box>
          <Snackbar
            open={snack.open}
            autoHideDuration={5000}
            onClose={(): void => setSnack({ ...snack, open: false })}
          >
            <Alert
              onClose={(): void => setSnack({ ...snack, open: false })}
              severity={snack.severity}
            >
              {snack.message}
            </Alert>
          </Snackbar>
        </Box>
      </Box>
    </Box>
  )
}
